import handleBuilderFormSubmit from './handle-builder-form-submit';
import handleCartFormChange from './handle-cart-form-change';
import setBuilderFormState from './set-builder-form-state';

const builderForm = document.querySelector('form#builder-form');
const cartForm = document.querySelector('form[id*="product_form"]');

if (builderForm && cartForm) {
  // two separate forms, one just has the submit button
  builderForm.addEventListener('submit', handleBuilderFormSubmit);

  cartForm.addEventListener('change', handleCartFormChange);
  setBuilderFormState();
}
